import { LanguageChooser } from "./LanguageChooser";
import { SUPPORTED_UI_LANGUAGES, useI18n } from "../i18n/i18n";
import { toLanguageOption } from "../i18n/languageCatalog";

type UiLanguageSwitcherProps = {
  className?: string;
};

export const UiLanguageSwitcher = ({ className = "" }: UiLanguageSwitcherProps) => {
  const { language, setLanguage, t } = useI18n();
  const uiLanguageOptions = SUPPORTED_UI_LANGUAGES.map((tag) => toLanguageOption(tag));

  return (
    <LanguageChooser
      closeLabel={t("view.closeLanguageSelector")}
      dialogTitle={t("view.chooseLanguage")}
      filterAriaLabel={t("view.filterLanguagesAria")}
      filterPlaceholder={t("view.filterLanguagesPlaceholder")}
      onSelect={setLanguage}
      options={uiLanguageOptions}
      selectedTag={language}
      triggerAriaLabel={t("uiLanguage.switcherAria")}
      triggerClassName={`theme-switcher ${className}`.trim()}
      triggerContent={<span className="ui-language-label">{language.toUpperCase()}</span>}
    />
  );
};
